/**
 * Dinheiro é `number` inteiro em centavos. `R$ 312,45` é `31245`. Nenhum float,
 * em nenhum lugar, nunca — ver [[ADR-0008 - Dinheiro em centavos inteiros]] e
 * `Docs/03-Arquitetura/Dinheiro, datas e fuso.md`.
 *
 * O sinal — negativo é saída, positivo é entrada — mora em `Transaction`, não
 * aqui. Estas funções só sabem somar e tirar sinal.
 */

/** Inteiro seguro em centavos. Negativo é saída, positivo é entrada. */
export type Cents = number

/**
 * A guarda da fronteira: o que entra do Firestore, de um formulário ou de um
 * provedor externo passa por aqui antes de virar `Cents`.
 *
 * `isSafeInteger` e não `isInteger`: acima de 2^53 a soma deixa de ser exata, e
 * uma soma inexata é justamente o bug que centavos inteiros existem para
 * impedir. `isSafeInteger` já recusa não-number, NaN e infinito.
 */
export function isValidCents(v: unknown): v is Cents {
  return Number.isSafeInteger(v)
}

/**
 * Valor absoluto. Não valida: quem recebe dado de fora chama `isValidCents`
 * primeiro, e pôr a validação aqui a poria também em todo laço de soma.
 */
export function absCents(v: Cents): Cents {
  return Math.abs(v)
}

/** Soma exata, porque as parcelas são inteiras. Lista vazia é zero. */
export function sumCents(values: Cents[]): Cents {
  return values.reduce((total, value) => total + value, 0)
}
